var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'brand-message',
    {
      'brand-message--blackfriday': _vm.$store.state.isBlackFriday,
    } ]},[_c('div',{staticClass:"container"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.homeSlogan)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }